<template>
    <div class="align-center px-4 py-3" style="display: flex">
      <div class="day-title sm:1/4 xs:1/4 md:1/4 lg:1/6 xl:1/6 pr-3">
        <div class="text-zt-lg font-bold">{{ formatDay(element.fecha) }}</div>
        <div class="text-zt-base text-zt-secondary-200 font-normal buttonSecondary--text">{{element.fecha}}</div>
          <div v-show="showBtnMore && element.cumplen.length > numberShow" class="inline-block mt-2">
            <zt-button data-vs-button="show-less" @click="showBtnMore = false; showMore(element.fecha.replace(/\//g, '-'))" color="primary" outlined icon="angle-down" class="text-zt-primary-200" fab>
            </zt-button>
          </div>
          <div v-show="!showBtnMore && element.cumplen.length > numberShow" class="inline-block mt-2">
            <zt-button data-vs-button="show-more" @click="showBtnMore = true; showLess(element.fecha.replace(/\//g, '-'))" color="primary" outlined icon="angle-up" class="text-zt-primary-200" fab></zt-button>
          </div>
      </div>
      <div :id="element.fecha.replace(/\//g, '-')" class="d-flex flex-wrap rowsDiv">
        <div v-for="(cumple, index2) in element.cumplen" :key="index2"
          class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 p-1 birthday-container">
          <zt-tooltip :text="cumple.nombreyapellido" color="primary">
            <div class="w-12 h-12 rounded-full flex items-center justify-center" :class="cumple.foto_perfil != '' && cumple.foto_perfil.includes('/profileimage') ? '' : 'bg-white border border-solid border-primary text-zt-primary-200'">
              <img class="rounded-full" v-if="cumple.foto_perfil != '' && cumple.foto_perfil.includes('/profileimage')"
                :src="cumple.foto_perfil">
              <div v-else>
                {{cumple.nombre.trim().charAt(0).toUpperCase() + cumple.apellido.trim().charAt(0).toUpperCase()}}
              </div>
              </div>
          </zt-tooltip>
        </div>
      </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    element: Object
  },

  data() {
    return {
      showBtnMore: true,
      numberShow: 8,

    }
  },

  async created() {
    window.addEventListener("resize", this.detectResolution);
    this.detectResolution();
  },

  destroyed() {
    window.removeEventListener("resize", this.detectResolution);
  },

  methods: {
    showMore(id){
      document.getElementById(id).classList.remove('rowsDiv');
    },

    showLess(id){
      document.getElementById(id).classList.add('rowsDiv');
    },

    formatDay(day){
      let today = new Date();
      if(moment(today).subtract(1,'days').format('DD/MM/YYYY') === moment(day,'DD/MM/YYYY').format('DD/MM/YYYY')) {
        // ayer
        return this.$t('message.homeComponent.birthdays.yesterday');
      } else if(moment(today).format('DD/MM/YYYY') === moment(day,'DD/MM/YYYY').format('DD/MM/YYYY')) {
        // hoy
        return this.$t('message.homeComponent.birthdays.today');
      } else if(moment(today).add(1,'days').format('DD/MM/YYYY') === moment(day,'DD/MM/YYYY').format('DD/MM/YYYY')) {
        // manana
        return this.$t('message.homeComponent.birthdays.tomorrow');
      } else {
        return moment(day,'DD/MM/YYYY').locale("es").format('dddd');
      }
    },
    detectResolution() {
      let resolution = window.screen.width;
      switch (true) {
        case (resolution < 500):
          this.numberShow = 6;
          break;
        case (resolution >= 501 && resolution <= 1023):
          this.numberShow = 9;
          break;
        case (resolution >= 1024 && resolution <= 1279):
          this.numberShow = 12;
          break;
        case (resolution >= 1280 && resolution <= 1439):
          this.numberShow = 14;
          break;
        case (resolution >= 1440 && resolution <= 1599):
          this.numberShow = 16;
          break;
        case (resolution >= 1600 && resolution <= 1919):
          this.numberShow = 21;
          break;
        case (resolution >= 1920 && resolution <= 2047):
          this.numberShow = 22;
          break;
        case (resolution >= 2048):
          this.numberShow = 23;
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@import "home.scss";

.day-title {
  min-width: 150px;
}
.birthday-container {
  max-width: 60px;
  font-size: $font-small;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.border-primary {
  border-color: $primary-color-200;
}
.rowsDiv {
  @media (min-width: 900px) {
    $line-height: 3;
    $font-size: 15px;
    $lines: 1;
    display: block;
    display: -webkit-box;
    height: $font-size * $line-height * $lines;
    font-size: $font-size;
    line-height: $line-height;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 900px) {
    align-items: center;
    $lines: 8;
    $font-size: 14px;
    $line-height: 1;
    display: block;
    display: -webkit-box;
    height: $font-size * $line-height * $lines;
    font-size: $font-size;
    line-height: $line-height;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.outline-unset {
  outline: unset;
}

</style>